import { Link, useLocation } from 'react-router-dom';
import { LogOut, Trash2, LayoutDashboard, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Logo } from '../common/Logo';
import { TeamSwitcher } from '../teams/TeamSwitcher';

export function Header() {
  const { user, signOut, isAdmin } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary shadow-lg">
      <div className="container-content h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/dashboard" className="flex items-center">
          <Logo variant="dark" />
        </Link>

        {/* Navigation */}
        <nav className="flex items-center gap-1">
          <Link
            to="/dashboard"
            className={`flex items-center gap-2 px-4 py-2 rounded-card transition-colors
              ${isActive('/dashboard') || isActive('/sites')
                ? 'bg-white/10 text-white'
                : 'text-white/70 hover:text-white hover:bg-white/5'
              }`}
          >
            <LayoutDashboard size={18} />
            <span className="text-body-sm font-medium">Dashboard</span>
          </Link>

          <Link
            to="/trash"
            className={`flex items-center gap-2 px-4 py-2 rounded-card transition-colors
              ${isActive('/trash')
                ? 'bg-white/10 text-white'
                : 'text-white/70 hover:text-white hover:bg-white/5'
              }`}
          >
            <Trash2 size={18} />
            <span className="text-body-sm font-medium">Trash</span>
          </Link>

          {isAdmin && (
            <Link
              to="/admin"
              className={`flex items-center gap-2 px-4 py-2 rounded-card transition-colors
                ${isActive('/admin')
                  ? 'bg-white/10 text-white'
                  : 'text-white/70 hover:text-white hover:bg-white/5'
                }`}
            >
              <Settings size={18} />
              <span className="text-body-sm font-medium">Admin</span>
            </Link>
          )}
        </nav>

        {/* Team Switcher & User Menu */}
        <div className="flex items-center gap-4">
          {/* Team Switcher - only visible if user has multiple teams */}
          <TeamSwitcher />

          {user && (
            <span className="text-body-sm text-white/70 hidden sm:block">
              {user.email}
            </span>
          )}
          <button
            onClick={signOut}
            className="flex items-center gap-2 px-3 py-2 text-white/70 hover:text-white
                       hover:bg-white/5 rounded-card transition-colors"
            title="Sign out"
          >
            <LogOut size={18} />
            <span className="text-body-sm font-medium hidden sm:block">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
